import { AccessDenied as e } from "../../errors/access-denied.mjs";
import { BadRequest as t, BadRequestWithViolations as n } from "../../errors/bad-request.mjs";
import { ConflictError as r } from "../../errors/conflict-error.mjs";
import { FailedDependency as i } from "../../errors/failed-dependency.mjs";
import { InternalError as a } from "../../errors/internal-error.mjs";
import { invalidTokenErrorMessages as o } from "../../errors/invalid-token-error.mjs";
import { LockedError as s } from "../../errors/locked-error.mjs";
import { MaintenanceError as c } from "../../errors/maintenance-error.mjs";
import { NetworkError as l } from "../../errors/network-error.mjs";
import { NotFound as u } from "../../errors/not-found.mjs";
import { PayloadTooLarge as d } from "../../errors/payload-too-large.mjs";
import { UnauthorizedResponse as f } from "../../errors/unauthorized-response.mjs";
import { UnprocessableContentError as p } from "../../errors/unprocessable-content-error.mjs";
import { AxiosError as m, isCancel as h } from "axios";
//#region src/fetch/http-base-client/get-error-mapper.ts
var g = (g) => {
	let _ = !1, v = [], y = () => g.post("/api/user/token/regenerate"), b = (e) => {
		v.push(e);
	}, x = () => {
		v.forEach((e) => e()), v = [];
	}, S = async (e) => {
		let t = e.config;
		if (!_) {
			_ = !0;
			try {
				return await y(), _ = !1, x(), await g(t);
			} catch (e) {
				throw _ = !1, v = [], e;
			}
		}
		return new Promise((e) => {
			b(() => {
				e(g(t));
			});
		});
	};
	return async (g) => {
		if (h(g)) throw g;
		if (g = g, g.code === m.ERR_NETWORK) throw new l();
		let _ = g.response;
		if (!_) throw g;
		switch (_.status) {
			case 400: throw "errors" in _.data ? new t(_.data) : new n(_.data);
			case 401:
				if (o.includes(_.data.message)) return await S(g);
				{
					let e = _.data.redirect || _.data.location;
					if (e) throw new f(e);
				}
				break;
			case 403: {
				let t = _.data?.redirect || _.data?.location;
				throw new e(t);
			}
			case 404: throw new u(u.isNotFoundResponse(_.data) ? _.data : void 0);
			case 409: throw new r(_.data);
			case 413: throw new d();
			case 422: throw new p(_.data);
			case 423: throw new s();
			case 424: throw new i(_.data.title);
			case 503: throw new c();
			case 500:
			case 502: throw new a();
		}
		throw g;
	};
};
//#endregion
export { g as getErrorMapper };
